import { type FunctionComponent, type MouseEvent } from 'react';
import { ClickableElement } from '../buttons';
import HeartIcon from '../svgs/untitled-ui/heart.svg';

export type QuickStartFavoriteButtonProps = {
	handleClick?: (e: MouseEvent<HTMLElement>) => void;
	isSelected: boolean;
};

export const QuickStartFavoriteButton: FunctionComponent<QuickStartFavoriteButtonProps> = ({ isSelected, handleClick }) => {
	let className = 'flex justify-center items-center br-100 w2 h2 pointer f4 shadow-2';
	let ariaLabel = '';
	if (isSelected) {
		className = `${className} bg-theme-error`;
		ariaLabel = 'unlike quickstart';
	} else {
		className = `${className} bg-theme-black-o60`;
		ariaLabel = 'like quickstart';
	}
	return (
		<ClickableElement ariaLabel={ariaLabel} onClick={handleClick}>
			<div className={className}>
				<HeartIcon className="theme-white" />
			</div>
		</ClickableElement>
	);
};
